// extracted by mini-css-extract-plugin
module.exports = {"phoneFooter":"VqMW3gh7+nsOIRY59OgjEw==","phoneDisplay":"hxuodhfCO-G35Nn9T32hpA==","phoneIcon":"gKew7JobYz3B2rKlhmlVCw=="};